
import './contant.css'
import { MapContainer , TileLayer , Marker , Popup } from 'react-leaflet';
import L from 'leaflet'
import tehranmuicon from '../../logo/tehranmulogo.jpg'
export default function Contact() {
    function title() {
      document.title = 'تهران مو | تماس'
    }
    title()
    const iconmap = new L.Icon({
      iconUrl: tehranmuicon,
      iconSize: [40, 40],
      iconAnchor: [20,20],
      popupAnchor: [0, -40],
    })
    const position = [35.71724054343673,51.218038063286755]
    return (
        <div className="contact-container">
          <div className="contact-box">
            <h1 className="company-name">تهران مو</h1>
            <div className="contact-info">
              <p><strong>آدرس:</strong> تهران کیلومتر 11 بزرگراه شهید لشکری خیابان 29 انتهای خیابان کارخانه تهران مو</p>
              <p><strong>شماره تماس:</strong> 021-44905741</p>
              <p><strong>پشتیبانی:</strong> 09125840641</p>
              <p><strong>اینستاگرام:</strong> <a href="https://instagram.com/tehran_mu.co"> tehran_mu.co</a></p>
              <MapContainer center={position} zoom={15} style={{height : '300px', width: '100%'}}>
                <TileLayer
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                />
                <Marker position={position} icon={iconmap}>
                  <Popup>
                    tehranmu
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>
          <div className="animations">
            <div className="animation-circle"></div>
            <div className="animation-triangle"></div>
            <div className="animation-square"></div>
          </div>
        </div>
      );
    }